import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {REPLACEMENT_DOG_STRING} from 'modules/GreyhoundRacing/consts';

import Cloth from 'modules/Common/components/Cloth';
import CaretIcon from 'modules/Common/components/svg/CaretIcon';

import {localFullDateShort} from 'utils/LocalDateTimeHelper';
import _ from 'lodash'

require('./GreyhoundRacingRacecardRunner.scss');

export default class GreyhoundRacingRacecardRunner extends Component {
  static propTypes = {
    runner: PropTypes.object,
    showLastRun: PropTypes.bool
  }

  constructor(props) {
    super(props);
    this.state = {
      formExpanded: false
    }
  }

  hasFormList() {
    const {runner: {greyhound: {previous_results: {length} = {}} = {}} = {}} = this.props;
    return !!length;
  }

  toggleFormExpanded() {
    this.setState({formExpanded: this.hasFormList() && !this.state.formExpanded});
  }

  toggleLastRunVideo() {
    this.setState({showLastRunVideo: !this.state.showLastRunVideo})
  }

  render(){
    const {
      runner : {
        clothNo,
        greyhoundName,
        trainer : {
          name: trainerName
        },
        form = 'N/A',
        greyhound,
        bestRunTime = 'N/A',
        lastRunTime = 'N/A',
        reserve
      }
    } = this.props;

    const {
      formExpanded
    } = this.state;

    const runnerHasForm = this.hasFormList();

    return (
      <section className='gh-racing-runner-wrapper'>
        <div className='gh-racing-runner-key-info-container'>
          <div className='gh-racing-runner-cloth'>
            <Cloth number={clothNo} />
          </div>
          <div className='gh-racing-runner-greyhound-info'>
            <div className='row'>
              <span className='gh-racing-runner-greyhound-name'>
                <span to={`/greyhounds/profiles/dog/${greyhoundName}`}>{greyhoundName}</span>
                <sup className='gh-racing-runner-greyhound-last-ran'>{`(${greyhound.sex}${greyhound.colour ? ` - ${greyhound.colour}` : ''})`}</sup>
              </span>
            </div>
            <div className='row'>
              <div className='gh-racing-runner-greyhound-sub-info'>
                <span>Best: {bestRunTime}</span>
                <span>Last: {lastRunTime}</span>
              </div>
            </div>
          </div>
          <div className='gh-racing-runner-betting-odds'>{/* placeholder */}</div>
        </div>
        <div className='gh-racing-runner-form-history-container'>
          <div className='gh-racing-runner-form-key-info'>
            <button className='gh-racing-runner-show-form' onClick={e=>this.toggleFormExpanded(e)} disabled={!runnerHasForm}>
              {runnerHasForm && <CaretIcon type='full' direction={formExpanded ? 'up' : 'down'}/>}
              <label className='gh-racing-runner-form-stat'><span>Form:</span>&nbsp;{form}</label>
            </button>

            <span className='gh-racing-runner-form-trainer'>T: {trainerName}</span>
          </div>
          { formExpanded &&
            <div className='gh-racing-runner-form-table'>
              <table className='default-table'>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Track</th>
                    <th>Dist</th>
                    <th>Trp</th>
                    <th>Split</th>
                    <th>Pos</th>
                    <th>By</th>
                    <th>SP</th>
                    <th>Time</th>
                  </tr>
                </thead>
                <tbody>
                  {greyhound.previous_results.map(result => <tr key={result.race_id}>
                    <td>{localFullDateShort(result.date)}</td>
                    <td>{result.course_name}</td>
                    <td>{`${result.distance}m`}</td>
                    <td>{result.trap_number}</td>
                    <td>{result.sectional_time}</td>
                    <td>{result.position}</td>
                    <td>{result.finish_distance || '-'}</td>
                    <td>{result.odds}</td>
                    <td>{result.run_time}</td>
                  </tr>)}
                </tbody>
              </table>
            </div>
          }
        </div>
        {
          <div className="gh-racing-runner-sire-dam-container">
            <span className="gh-racing-runner-sire-dam-text">{`${_.get(greyhound, "sire.name", "Unknown")}/${_.get(greyhound, "dam.name", "Unknown")}`}</span>
            {
              reserve && <span className="gh-racing-runner-reserve-text">{REPLACEMENT_DOG_STRING}</span>
            }
          </div>
        }
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/components/GreyhoundRacingRacecardRunner.js